import React from "react";
import CustomButton from "../components/CustomButton";
import { useNavigate } from "react-router-dom";

export default function NoPage() {
  const router = useNavigate();
  return (
    <div className="flex flex-col w-full justify-center items-center p-10 gap-16">
      <div className="text-xl">Error</div>
      <div className="text-9xl">404</div>
      <div className="text-3xl">NOT FOUND</div>
      <CustomButton
        txt={"กลับสู่หน้าหลัก"}
        onClick={() => {
          router("/", { replace: true });
        }}
      />
    </div>
  );
}
